import { useQuery } from '@tanstack/react-query';

import { getClassDetails } from '@/services/class';

export default function useClass({ slug }: { slug: string }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['class', slug],
    queryFn: () => getClassDetails({ slug }),
    enabled: !!slug,
  });

  return {
    data,
    isLoading,
    error,
  };
}
